module.exports = __webpack_public_path__ + "static/3-16f088dc0b4cac7092b504f3314fcd4f.png";